// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","361":"coals","412":"commingsoon","562":"lobster","983":"products"}[chunkId] + "." + {"353":"4defdf49","361":"3ad7f399","412":"3d31b73f","562":"7ada338d","983":"a616e973"}[chunkId] + ".css";
};